import qs from 'qs'

export const queryEducationPage = (locale: QueryLocaleString) => {
  const query = qs.stringify(
    {
      locale: locale || 'en-US',
      fields: [
        'title',
        'richText',
        'introduction'
      ],
      populate: {
        ...queryFragmentSeo
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `education-page?${query}`
}
